import { Box } from '@mui/material';

export interface InfoBoxProps {
  children: React.ReactNode;
}

export const InfoBoxSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  px: 3,
  borderRadius: 2,
  height: 48,
  backgroundColor: 'surfaceContainerLow.main',
};

export default function InfoBox({ children }: InfoBoxProps): React.JSX.Element {
  return (
    <Box sx={InfoBoxSx}>
      {children}
    </Box>
  );
}
